// extracted by css-extract-rspack-plugin
export default {"slottedList":"IssuesListSlots-module__slottedList__GHnrY","slottedListBody":"IssuesListSlots-module__slottedListBody__A6HoI"};